export const stripHtmlTags = (data: string): string => data.replace(/<\/?[^>]+(>|$)/g, "");

export const stripHtmlTagsOfArray = (props: Array<string>) => props.map(stripHtmlTags);
